import { combineReducers } from 'redux';

import cadastro from './cadastro/reducer';
import consulta from './consulta/reducer';

export default combineReducers({
	cadastro,
	consulta,
});
